import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../../Service/ApiCallMethod";
import { LIMIT_PER_PAGE } from "../../../Common/Constants";

export const getPlanTypeList = createAsyncThunk(
  "user/get-plan-type-list",
  async (planTypeParams, thunkAPI) => {
    try {
      const search = planTypeParams?.searchText
        ? planTypeParams.searchText
        : "";
      const page = planTypeParams?.page ? planTypeParams.page : "";
      const limit = planTypeParams?.limit
        ? planTypeParams.limit
        : LIMIT_PER_PAGE;
      const response = await getMethod(
        "/user/plan/list-of-plan-types-and-features?keyword=" +
          search +
          "&page=" +
          page +
          "&limit=" +
          limit
      );
      const data = await response.data;
      if (response.status != 200 && response.status != 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

const initialState = {
  planTypeListData: null,
  loading: false,
  error: null,
};

export const GetPlanTypeListSlice = createSlice({
  name: "get-plan-type-list",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPlanTypeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlanTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.planTypeListData = action.payload;
        state.error = null; // Clear any previous errors
      })
      .addCase(getPlanTypeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetPlanTypeListSlice.reducer;
